import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import classnames from 'classnames';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

import Tag from 'components/Ui/Tag';
import Menu from 'components/Ui/Menu';
import Modal from 'components/Ui/Modal';
import Button from 'components/Ui/Button';
import { Small } from 'components/Ui/Text';
import Category from 'components/Ui/Category';
import { Table, Row, Cell } from 'components/Ui/Table';
import { Container, Element, ItemGroup, Item, Header, HeaderItem } from 'components/Ui/Collection';
import { useDimensions } from 'hooks';

// const Menu = () => {
// 	return (
// 		<div className="relative">
// 			<Show if={true}>
// 				<div className="absolute bottom-0 right-0 bg-white border border-neutral-100 rounded-lg">
// 					<div className="h-6 leading-6">Labot</div>
// 				</div>
// 			</Show>
// 		</div>
// 	);
// };

// const Modal = ({ title, visible, onModal, children, footer }) => {
// 	if (!visible) return null;

// 	return createPortal(
// 		<div className="fixed top-0 right-0 bottom-0 left-0 z-10 sm:p-4 flex justify-center items-center bg-[rgba(0,0,0,0.15)] dark:bg-[rgba(0,0,0,0.55)] backdrop-blur-sm">
// 			<div className="w-full flex flex-col max-w-lg max-h-full bg-white dark:bg-neutral-900 rounded-lg overflow-hidden animate-fade-in">
// 				<div className="py-4 px-4 pl-6 flex justify-between items-center">
// 					<div className="text-xl font-semibold text-neutral-700 dark:text-neutral-100">{title}</div>
// 					<IconButton icon="close" onClick={onModal} />
// 				</div>

// 				<div className="px-4 pb-4 max-h-full overflow-y-auto">
// 					{children}
// 				</div>

// 				<Show if={footer}>
// 					{footer}
// 				</Show>
// 			</div>
// 		</div>
// 		, document.body);
// };

const Title = ({ value }) => {
	return (
		<div className="font-semibold text-neutral-700 dark:text-neutral-100">{value}</div>
	);
};

const Description = ({ value }) => {
	return (
		<div className="text-sm font-normal text-neutral-500 dark:text-neutral-500">{value}</div>
	);
};

const Input = ({ label, description, required }) => {
	return (
		<div className="flex flex-col space-y-2">
			<label
				className="font-semibold text-neutral-700 dark:text-neutral-100 text-sm"
			>
				{label}

				<Show if={required}>
					<Icon icon="emergency" className="text-sm text-rose-500 font-normal ml-0.5 -mt-1" />
				</Show>
			</label>

			<input
				type="text"
				className="h-10 leading-10 px-4 text-sm bg-transparent border dark:border-neutral-700 border-neutral-200 rounded-lg text-neutral-700 dark:text-neutral-100 focus:ring-2 focus:ring-amber-500 transition-all"
			/>

			<Description value={description} />
		</div>
	);
};

const Files = ({ label, description, required }) => {
	return (
		<div className="flex flex-col space-y-2">
			<label
				className="font-semibold text-neutral-700 dark:text-neutral-100"
			>
				{label}

				<Show if={required}>
					<Icon icon="emergency" className="text-sm text-rose-500 font-normal ml-0.5 -mt-1" />
				</Show>
			</label>

			<div className="border border-dashed border-neutral-200 dark:border-neutral-700 py-8 px-4 rounded-lg flex flex-col text-center cursor-pointer hover:ring-2 hover:ring-amber-500 hover:border-transparent transition-all">
				<Icon icon="file_upload" className="text-neutral-700 dark:text-neutral-100 text-xl mb-2" />

				<div className="text-neutral-700 dark:text-neutral-100 text-sm">Nometiet savus failus šeit vai <span className="text-amber-500">noklikšķiniet, lai pārlūkotu</span></div>
				<div className="mt-0.5 text-[13px] text-neutral-500 dark:text-neutral-500 font-normal">Izvēlieties ne vairāk kā 10 failus, katrs līdz 10 MB.</div>
			</div>

			<Description value={description} />
		</div>
	);
};

const Dates = () => {
	return (
		<div className="px-3 flex max-w-fit text-neutral-700 dark:text-neutral-100 space-x-0.5 font-normal items-center rounded-lg cursor-pointer hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors">
			<div className="text-sm h-10 leading-10">7. dec, 2022</div>

			<Icon icon="horizontal_rule" className="text-lg" />

			<div className="text-sm h-10 leading-10">23. dec, 2022</div>

			<Icon icon="expand_more" className="text-lg" />
		</div>
	);
};

const Select = () => {
	return (
		<select
			className="pl-3 pr-6 h-10 leading-10 text-sm text-neutral-700 dark:text-neutral-100 rounded-lg cursor-pointer hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors appearance-none"
		>
			<option value="1">Aktīvs</option>
			<option value="2">Slēpts</option>
		</select>
	);
};

// const Tag = ({ value, theme = 'default' }) => {
// 	const cls = classnames(
// 		'inline-block px-2.5 h-7 text-sm text-center leading-7 rounded-full font-semibold',
// 		theme === 'default' && 'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-100',
// 		theme === 'success' && 'bg-emerald-500 text-white',
// 		theme === 'warning' && 'bg-sky-500 text-white',
// 		theme === 'danger' && 'bg-rose-500 text-white',
// 	);
// 	return (
// 		<div className={cls}>
// 			{value}
// 		</div>
// 	);
// };

// const Category = ({ title, hide = false, children }) => {
// 	const [show, setShow] = useState(!hide);
// 	const toggle = () => setShow(p => !p);

// 	return (
// 		<div className="">
// 			<div className="px-4 h-10 leading-10 flex justify-between bg-neutral-100 dark:bg-neutral-800 rounded-lg cursor-pointer hover:bg-neutral-200 dark:hover:bg-neutral-700 transition-colors" onClick={toggle}>
// 				<Title value={title} />
// 				<Icon icon={show ? 'expand_less' : 'expand_more'} className="text-neutral-700 dark:text-neutral-100" />
// 			</div>

// 			<Show if={show}>
// 				<div className="py-3 px-4 space-y-2 animate-fade-in">
// 					{children}
// 				</div>
// 			</Show>
// 		</div>
// 	);
// };

const Tooltip = ({ text, children }) => {
	const tooltipClassName = classnames(
		'absolute left-1/2 -translate-x-1/2 bottom-11 ring-1 ring-neutral-100 py-1 px-2 whitespace-nowrap text-sm text-neutral-700 font-semibold bg-white rounded-lg hidden group-hover:block',
		'after:absolute after:block after:w-4 after:left-1/2 after:-translate-x-1/2 after:-bottom-2 after:border-solid after:border-t-8 after:border-x-transparent after:border-x-8 after:border-b-0',
		'bg-white after:border-t-white',
		'dark:bg-neutral-900 dark:after:border-t-neutral-900 dark:ring-neutral-700 dark:text-neutral-100'
	);

	return (
		<div className="relative group w-fit">
			<div className={tooltipClassName}>
				{text}
			</div>

			{children}
		</div>
	);
};

const Group = () => {
	return (
		<div className="inline-flex rounded-lg text-xl cursor-pointer hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors">
			<Tooltip text="Saraksts">
				<div className="w-10 h-10 flex items-center justify-center text-neutral-400 dark:text-neutral-500">
					<Icon icon="format_list_bulleted" />
				</div>
			</Tooltip>

			<Tooltip text="Režģis">
				<div className="w-10 h-10 flex items-center justify-center text-neutral-700 dark:text-neutral-100">
					<Icon icon="grid_view" />
				</div>
			</Tooltip>
		</div>
	);
};

const IconButton = ({ icon, onClick }) => {
	return (
		<div className="inline-flex justify-center items-center w-10 h-10 rounded-lg text-xl text-neutral-700 dark:text-neutral-100 cursor-pointer hover:bg-neutral-100 dark:hover:bg-neutral-800 transition-colors" onClick={onClick}>
			<Icon icon={icon} />
		</div>
	);
};

const Submit = ({ value, theme, className, onClick }) => {
	const cls = classnames(
		'inline-flex justify-center items-center px-4 h-10 rounded-lg text-sm font-semibold cursor-pointer transition-colors',
		!theme && 'text-neutral-700 bg-neutral-100 hover:bg-neutral-200',
		theme && theme,
		className,
	);

	return (
		<div className={cls} onClick={onClick}>
			{value}
		</div>
	);
};

const Test = () => {
	const [ref, dimensions] = useDimensions();

	const [visible, setVisible] = useState(false);
	const onModal = () => setVisible(prev => !prev);

	const [display, setDisplay] = useState('table');
	const onDisplay = () => setDisplay(prev => prev === 'table' ? 'grid' : 'table');

	console.log(dimensions);

	const head = classnames(
		'py-1 px-2 bg-neutral-800 first:border-l border-r border-neutral-700',
		'group-first:border-t',
		'group-first:first:rounded-tl-lg group-first:last:rounded-tr-lg'
	);

	const desktop = classnames(
		'py-1 px-2 bg-neutral-800 first:border-l border-r border-b border-neutral-700',
		'group-first:border-t',
		'group-last:first:rounded-bl-lg group-last:last:rounded-br-lg'
	);

	const mobile = classnames(
		'py-1 px-2 bg-neutral-800 first:border-l border-r border-b border-neutral-700',
		'group-first:border-t',
		'group-first:first:rounded-tl-lg group-first:last:rounded-tr-lg',
		'group-last:first:rounded-bl-lg group-last:last:rounded-br-lg'
	);

	return (
		<div className="bg-white dark:bg-neutral-900 font-sans antialiased">
			<div className="w-full">
				<table className="w-full border-separate border-spacing-0 hidden md:table">
					<thead>
						<tr className="group">
							<th className={head}>1</th>
							<th className={head}>2</th>
							<th className={head}>3</th>
							<th className={head}>4</th>
						</tr>
					</thead>
					<tbody>
						<tr className="group">
							<td className={desktop}>1</td>
							<td className={desktop}>2</td>
							<td className={desktop}>3</td>
							<td className={desktop}>4</td>
						</tr>
						<tr className="group">
							<td className={desktop}>1</td>
							<td className={desktop}>2</td>
							<td className={desktop}>3</td>
							<td className={desktop}>4</td>
						</tr>
						<tr className="group">
							<td className={desktop}>1</td>
							<td className={desktop}>2</td>
							<td className={desktop}>3</td>
							<td className={desktop}>4</td>
						</tr>
					</tbody>
				</table>

				<table className="w-full border-separate border-spacing-0 md:hidden">
					<tbody>
						<tr className="group">
							<td className={mobile}>1</td>
							<td className={mobile}>2</td>
							<td className={mobile}>3</td>
							<td className={mobile}>4</td>
						</tr>
						<tr className="group">
							<td className={mobile}>1</td>
							<td className={mobile}>2</td>
							<td className={mobile}>3</td>
							<td className={mobile}>4</td>
						</tr>
						<tr className="group">
							<td className={mobile}>1</td>
							<td className={mobile}>2</td>
							<td className={mobile}>3</td>
							<td className={mobile}>4</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div ref={ref} className="">
				Test
			</div>

			<div className="grid md:grid-cols-3 gap-4">
				<div className="space-y-2">
					<Category title="Pamatinformācija">
						<Small value="Iedod savam produktam salasāmu nosaukumu. 40-50 simboli ir ieteicams garums priekš meklētājiem." />

						<Input
							required
							label="Vārds"
							description="Lietotāja vārds pēc kura to būs iespējams atrast sistēmā."
						/>

						<Input
							label="Uzvārds"
							description="Lietotāja vārds pēc kura to būs iespējams atrast sistēmā."
						/>
					</Category>
				
					<Category title="Pedagogs" hide>
						<Small value="Iedod savam produktam salasāmu nosaukumu. 40-50 simboli ir ieteicams garums priekš meklētājiem." />
					</Category>

					<Category title="Mācību moduļi" hide>
						<Small value="Iedod savam produktam salasāmu nosaukumu. 40-50 simboli ir ieteicams garums priekš meklētājiem." />
					</Category>
				</div>

				<div>
					<Group />

					{/* <Tooltip text="Izvēlēties sākuma un beigu datumus"> */}
					<Dates />

					<Select />
					{/* </Tooltip> */}

					<div className="flex space-x-2">
						<Tag value="Pievienots" />
						<Tag value="Aktīvs" theme="success" />
						<Tag value="Iesniegts" theme="warning" />
						<Tag value="Anulēts" theme="danger" />
					</div>
				</div>

				<div>
					<div className="py-3 px-4 bg-rose-500 dark:bg-rose-500 rounded-lg text-sm text-white">
						Modulī ir atrasti <span className="font-bold">3 studenti</span>, kuriem nav pievienots pārbaudes darbs!
					</div>

					<div className="mt-4 flex gap-4 flex-wrap">
						<Button value="Saglabāt izmaiņas" />
						<Button value="Saglabāt izmaiņas" theme="primary" />
						<Button value="Saglabāt izmaiņas" theme="darker" />
						<Button value="Saglabāt izmaiņas" theme="success" />
						<Button value="Saglabāt izmaiņas" theme="danger" />
					</div>

					<div className="mt-4 flex gap-4 flex-wrap">
						<Button value="Saglabāt izmaiņas" submit />
						<Button value="Saglabāt izmaiņas" submit theme="primary" />
						<Button value="Saglabāt izmaiņas" submit theme="darker" />
						<Button value="Saglabāt izmaiņas" submit theme="success" />
						<Button value="Saglabāt izmaiņas" submit theme="danger" />
					</div>

					<div className="mt-4 flex gap-4 flex-wrap">
						<Button value="Saglabāt izmaiņas" icon="check" />
						<Button value="Saglabāt izmaiņas" icon="edit" theme="primary" />
						<Button value="Saglabāt izmaiņas" icon="check" theme="darker" />
						<Button value="Saglabāt izmaiņas" icon="check" theme="success" />
						<Button value="Saglabāt izmaiņas" icon="delete" theme="danger" />
					</div>

					<div className="mt-4 flex gap-4 flex-wrap">
						<Button value="Saglabāt izmaiņas" to="/test" />
						<Button value="Saglabāt izmaiņas" to="/test" theme="primary" />
						<Button value="Saglabāt izmaiņas" to="/test" theme="darker" />
						<Button value="Saglabāt izmaiņas" to="/test" theme="success" />
						<Button value="Saglabāt izmaiņas" to="/test" theme="danger" />
					</div>

					<div className="mt-4 flex gap-4 flex-wrap">
						<Button value="Saglabāt izmaiņas" outside="https://www.google.lv" />
						<Button value="Saglabāt izmaiņas" outside="https://www.google.lv" theme="primary" />
						<Button value="Saglabāt izmaiņas" outside="https://www.google.lv" theme="darker" />
						<Button value="Saglabāt izmaiņas" outside="https://www.google.lv" theme="success" />
						<Button value="Saglabāt izmaiņas" outside="https://www.google.lv" theme="danger" />
					</div>

					<div className="mt-4 flex flex-wrap gap-4">
						<Button value="Saglabāt izmaiņas" small />
						<Button value="Saglabāt izmaiņas" small theme="primary" />
						<Button value="Saglabāt izmaiņas" small theme="darker" />
						<Button value="Saglabāt izmaiņas" small theme="success" />
						<Button value="Saglabāt izmaiņas" small theme="danger" />
					</div>

					<div className="mt-4 flex flex-wrap gap-4">
						<Button icon="more_horiz" square />
						<Button icon="more_horiz" square theme="primary" />
						<Button icon="more_horiz" square theme="darker" />
						<Button icon="more_horiz" square theme="success" />
						<Button icon="more_horiz" square theme="danger" />
					</div>

					<div className="mt-4 flex flex-wrap gap-4">
						<Button icon="more_horiz" small square />
						<Button icon="more_horiz" small square theme="primary" />
						<Button icon="more_horiz" small square theme="darker" />
						<Button icon="more_horiz" small square theme="success" />
						<Button icon="more_horiz" small square theme="danger" />
					</div>

					<div className="mt-4 flex flex-wrap">
						<Button icon="more_horiz" small square theme="transparent" />
						<Button icon="share" small square theme="transparent" />
						<Button icon="visibility" small square theme="transparent" />
					</div>

					<div className="mt-4 flex flex-wrap">
						<Button icon="more_horiz" square theme="transparent" />
						<Button icon="share" square theme="transparent" />
						<Button icon="visibility" square theme="transparent" />
					</div>
				</div>

				<div className="flex space-x-4">
					<Menu handler={(props) => <Button icon="more_horiz" square {...props} />} />
					<Menu placement="bl" handler={(props) => <Button icon="more_horiz" square {...props} />} />
					<Menu placement="bc" handler={(props) => <Button icon="more_horiz" square {...props} />} />
				</div>

				<div>
					<IconButton icon="share" />
					<IconButton icon="visibility" />
					<IconButton icon="more_horiz" />
				</div>

				<Submit value="Izveidot" theme="bg-amber-500 text-white hover:bg-amber-400" className="flex-1" onClick={onModal} />

				<Modal
					title="Veikt izmaiņas"
					visible={visible}
					onModal={onModal}
					footer={
						<div className="p-4 flex space-x-2 bg-neutral-100 dark:bg-neutral-800 font-sans antialiased">
							<Button value="Atcelt" theme="darker" />
							<Button value="Izveidot" theme="primary" className="flex-1" onClick={onModal} />
						</div>
					}
				>
					<div className="space-y-2 font-sans antialiased">
						<Category title="Pamatinformācija">
							<Small value="Iedod savam produktam salasāmu nosaukumu. 40-50 simboli ir ieteicams garums priekš meklētājiem." />
						
							<Input
								required
								label="Vārds"
								description="Lietotāja vārds pēc kura to būs iespējams atrast sistēmā."
							/>

							<Input
								label="Uzvārds"
								description="Lietotāja vārds pēc kura to būs iespējams atrast sistēmā."
							/>
						</Category>
				
						<Category title="Pedagogs" hide>
							<Small value="Iedod savam produktam salasāmu nosaukumu. 40-50 simboli ir ieteicams garums priekš meklētājiem." />

							<Files />
						</Category>

						<Category title="Mācību moduļi" hide>
							<Small value="Izvēlieties ne vairāk kā 10 failus, katrs līdz 10 MB." />
						</Category>
					</div>
				</Modal>
			</div>

			<div className="max-w-full overflow-x-auto">
				<table className="mt-4 w-full whitespace-nowrap">
					<thead className="text-left text-sm text-neutral-500 dark:text-neutral-400 font-normal">
						<tr className="bg-neutral-100 dark:bg-neutral-800 h-10">
							<th className="px-4 font-normal rounded-l-lg">#</th>
							<th className="px-4 w-full font-normal">Students</th>
							<th className="px-4 font-normal">Datums</th>
							<th className="px-4 font-normal rounded-r-lg">Statuss</th>
						</tr>
					</thead>
					<tbody className="text-sm text-neutral-700 dark:text-neutral-100">
						<tr className="h-10">
							<td className="px-4">23</td>
							<td className="px-4 w-full">Ričards Kalniņš</td>
							<td className="px-4">23. dec, 2022 - 13. jan, 2023</td>
							<td className="px-4">
								<Tag value="Pievienots" />
							</td>
						</tr>

						<tr className="h-10">
							<td className="px-4">23</td>
							<td className="px-4 w-full">Ričards Kalniņš</td>
							<td className="px-4">23. dec, 2022 - 13. jan, 2023</td>
							<td className="px-4">
								<Tag value="Anulēts" theme="danger" />
							</td>
						</tr>

						<tr className="h-10">
							<td className="px-4">23</td>
							<td className="px-4 w-full">Ričards Kalniņš</td>
							<td className="px-4">23. dec, 2022 - 13. jan, 2023</td>
							<td className="px-4">
								<Tag value="Iesniegts" theme="warning" />
							</td>
						</tr>

						<tr className="h-10">
							<td className="px-4">23</td>
							<td className="px-4 w-full">Ričards Kalniņš</td>
							<td className="px-4">23. dec, 2022 - 13. jan, 2023</td>
							<td className="px-4">
								<Tag value="Aktīvs" theme="success" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div className="my-4 flex flex-wrap justify-end gap-4">
				<Button icon={display === 'table' ? 'format_list_bulleted' : 'grid_view'} square onClick={onDisplay} />
			</div>

			<div className="">
				<Container type={display}>
					{/* Display table header */}
					<Header>
						<HeaderItem tableClassName="w-full">Students</HeaderItem>
						<HeaderItem>Sākuma datums</HeaderItem>
						<HeaderItem>Beigu datums</HeaderItem>
						<HeaderItem>Statuss</HeaderItem>
						<HeaderItem></HeaderItem>
					</Header>

					{/* Display table body */}
					{entries.map(obj =>
						<Element
							key={obj.id}
						>
							<ItemGroup gridClassName="w-full flex">
								<Item
									gridClassName="flex-1 font-semibold"
									tableClassName="w-full font-semibold"
								>
									{obj.name}
								</Item>

								<Item tableClassName="hidden">
									<Menu handler={(props) => <Button icon="more_horiz" small square {...props} />} />
								</Item>
							</ItemGroup>

							<ItemGroup gridClassName="mb-2 flex w-full space-x-2">
								<Item>{obj.startDate}</Item>
								<Item tableClassName="hidden">-</Item>
								<Item>{obj.endDate}</Item>
							</ItemGroup>

							<Item>
								<Tag value={obj.status} theme="success" />
							</Item>

							<Item gridClassName="hidden">
								<Menu handler={(props) => <Button icon="more_horiz" iconClassName="font-semibold" small square {...props} />} />
							</Item>
						</Element>
					)}
				</Container>
			</div>
		</div>
	);
};

const entries = [
	{ id: 1, name: 'Ricards Kalnins', startDate: '20. nov, 2022', endDate: '23. dec, 2022', status: 'Pievienots' },
	{ id: 2, name: 'Ricards Kalnins', startDate: '20. nov, 2022', endDate: '23. dec, 2022', status: 'Pievienots' },
	{ id: 3, name: 'Ricards Kalnins', startDate: '20. nov, 2022', endDate: '23. dec, 2022', status: 'Pievienots' },
	{ id: 4, name: 'Ricards Kalnins', startDate: '20. nov, 2022', endDate: '23. dec, 2022', status: 'Pievienots' },
	{ id: 5, name: 'Ricards Kalnins', startDate: '20. nov, 2022', endDate: '23. dec, 2022', status: 'Pievienots' },
];

export default Test;